import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Bullet from "src/features/wizard/Bullet";
const BulletSteps = ({ totalSteps, active }) => {
    const bullets = new Array(totalSteps).fill(0);
    return (_jsx(_Fragment, { children: bullets.map((bullet, index) => _jsx(Bullet, { isActive: active === index + 1 })) }));
};
export default BulletSteps;
